import './propdi.scss';

const propdi = {
  title: "Gestão do Programa de Pesquisa, Desenvolvimento e Inovação (PROPDI) regulado pela ANEEL",
  content: (
    <div className="propdi-wrapper">
      <h4>Gestão do Programa</h4>
      <ul>
        <li>Apoio na elaboração do Plano Estratégico Quinquenal de Inovação (PEQuI).</li>
        <li>Apoio e orientação para a elaboração de projetos de PDI.</li>
        <li>Visita às empresas executoras para checar a execução física dos projetos bem como a aplicação dos recursos.</li>
        <li>Apoio na elaboração dos contratos entre as empresas executoras e as concessionária.</li>
        <li>Acompanhamento da execução física e técnica dos projetos.</li>
        <li>Acompanhamento dos KRs com projeção do atendimento a regulação.</li>
        <li>Elaboração e acompanhamento do índice da conta contábil (ICSCC).</li>
        <li>Acompanhamento dos encargos setoriais (MME e FNDCT).</li>
        <li>Representação junto a ANEEL.</li>
        <li>Encaminhamento trimestral via ConectANEEL e PINSE.</li>
        <li>Apoio na elaboração das evidências, controle contábil e exigências da ANEEL.</li>
        <li>Encerramento dos projetos com apoio na documentação.</li>
        <li>Ajustes contábeis necessários.</li>
        <li>Encerramento dos ciclos dos PROPDI.</li>
        <li>Apoio na contratação de auditoria e envio de documentação.</li>
        <li>Envio final à ANEEL.</li>
      </ul>

      <h4>Ajuste dos projetos de PDI para atender a Lei do Bem</h4>
      <ul>
        <li>Ajuste dos projetos para atender o MCTI.</li>
        <li>Encaminhamento dos projetos elegíveis.</li>
        <li>Acompanhamento da avaliação do MCTI.</li>
        <li>Ajuste dos relatórios mensais.</li>
        <li>Apresentação de recursos.</li>
      </ul>
    </div>
  )
};

export default propdi;